import { render, staticRenderFns } from "./powerbiReportViewer.vue?vue&type=template&id=ea97091c&scoped=true"
import script from "./powerbiReportViewer.vue?vue&type=script&setup=true&lang=js"
export * from "./powerbiReportViewer.vue?vue&type=script&setup=true&lang=js"
import style0 from "./powerbiReportViewer.vue?vue&type=style&index=0&id=ea97091c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea97091c",
  null
  
)

export default component.exports